import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n'; // Инициализация i18n
import './index.css';
import reportWebVitals from './reportWebVitals';

// Global error handlers
const handleGlobalError = (event: ErrorEvent) => {
  console.error('Global error caught:', event.error);
  // notificationStore.showError(i18n.t('errors.appError'));
  event.preventDefault();
};

const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
  console.error('Unhandled promise rejection:', event.reason);
  // notificationStore.showError(i18n.t('errors.operationError'));
  event.preventDefault();
};

// Add global error handlers
window.addEventListener('error', handleGlobalError);
window.addEventListener('unhandledrejection', handleUnhandledRejection);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
